export default __webpack_public_path__ + "assets/img/lemon_logo_light.e8ef60b2eb7ff14322c9da8de1b1d84d.svg";